import { CalendarEvent } from 'calendar-utils';

/**
 * The output `$event` type when an event is resized or dragged and dropped.
 */
export interface CalendarEventTimesChangedEvent {
  event: CalendarEvent;
  newStart: Date;
  newEnd?: Date;
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
